<template>
<div :class="container">
  <div v-if="loading" class="text-center"><i class="fas fa-spinner fa-spin"></i></div>
  <div v-else-if="categories.length == 0" class="text-center">No categories</div>
            <div class="row pt-2 px-2">
                <div class="col-md-3 px-3 col-6 p-0 px-md-2 mb-3" v-for="(category, index) in categories" :key="index">
                    
                    <a :href="`/category/${category.id}/${createSlug(category.name)}`" class="cardlink">
                      <div class="card video w-100 py-3 px-3 text-center">
                          <h4 class="video-list-name">{{category.name}}</h4>
                      </div>
                    </a>
                
                </div>
            </div>

        </div>
</template>

<script>
export default {
props : ['category_id', 'container', 'category_id'],

  data() {
    return {
      categories: [],
      loading: false,
    };
  },

  created() {
    this.getCategories();
  },

  methods: {

    getCategories() {

      this.loading = true;

      axios
        .get('/cat/list/'+this.category_id)
        .then((response) => {
          this.categories = response.data;
          this.loading = false;
        });
    },

  },
};
</script> 
